// Categories visible inside the monthly overview cells (per Phase 2 spec).
// The 6 additional categories (health/social/family/cooking/study/animal care)
// are real activities and draw bars like the primary activity categories; only
// sleep/free/transition stay blank in the month view.
export const MONTH_VISIBLE_CATEGORIES = new Set([
  "work",
  "exercise",
  "own_project",
  "planned_free_time",
  "entertainment",
  "chores",
  "health_improvement",
  "social_activity",
  "family_services",
  "cooking",
  "study",
  "animal_care",
]);
